import React from 'react';
import { Wrench, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import TiltCard from '../TiltCard';
import ScrollReveal from '../ScrollReveal';

const iconMap = {
  'wrench': Wrench,
};

const ServicesSection = ({ services, fullIconMap, heading, subheading }) => {
  return (
    <section id="services" className="py-20 bg-slate-950/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {heading || 'Our Services'}
            </h2>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              {subheading || 'Comprehensive gunsmithing services tailored to your needs'}
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {services.map((service, index) => {
            const IconComponent = fullIconMap[service.icon] || Wrench;
            return (
              <ScrollReveal key={service.id} delay={index * 100}>
                <TiltCard className="h-full">
                  <Card 
                    className="bg-slate-800 border-slate-700 hover:border-gray-400/50 transition-all duration-300 group h-full"
                  >
                    <CardHeader>
                      <div className="w-14 h-14 bg-gray-400/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-gray-400/20 transition-colors">
                        <IconComponent className="w-7 h-7 text-gray-300" />
                      </div>
                      <CardTitle className="text-white text-xl">{service.title}</CardTitle>
                      <CardDescription className="text-white leading-relaxed">
                        {service.description}
                      </CardDescription>
                    </CardHeader>
                    <CardContent>
                      <ul className="space-y-2">
                        {service.features.map((feature) => (
                          <li key={feature} className="flex items-center text-white text-sm">
                            <ChevronRight className="w-4 h-4 text-gray-300 mr-2 flex-shrink-0" />
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </CardContent>
                  </Card>
                </TiltCard>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
